import { type FC, memo } from 'react';
import styles from './wallet-unconnect.module.scss';
import { walletConnectModel } from '@models/wallet-connect.model';
import connectIcon from '@assets/images/header/connect.svg';

const WalletUnconnect: FC = () => {
  return (
    <>
      <div className={styles.button} key="not-connected" onClick={walletConnectModel.toggleDialog}>
        <span>Connect</span>
        <img src={connectIcon} data-icon />
      </div>
    </>
  );
};

export default memo(WalletUnconnect);
